import React from 'react';
import Hero from "../../common/Hero/Hero";
import { useTranslation } from "react-i18next";
import { Container, Row, Col } from "react-bootstrap";
import { getCorrectLink } from '../../../helpers/helpers'
import getMenuConfig from "../../../helpers/menuConfig";
import './TracciamentoNuoveReti.scss';

const TracciamentoNuoveReti = () => {
  const { t } = useTranslation();
  const { tracciamentoNuoveReti } = getMenuConfig();
  return (
    <div className="TracciamentoNuoveReti" data-testid="TracciamentoNuoveReti">
      <Hero
        backTo={"/"}
        backToText={t("common.back.home")}
        title={t("tracciamenti_reti.title")}
      />

      <Container>
        <Row>
          <Col className={'gcap-rich-text font-color-1'} style={{ marginBottom: 60 }}>
            <p dangerouslySetInnerHTML={{ __html: t('tracciamento_reti.paragraph1') }} />
            <ul>
              <li>
                <p dangerouslySetInnerHTML={{ __html: t('tracciamento_reti.list_item1', { link1: 'mailto:capholding@legalmail.it', link2: getCorrectLink(tracciamentoNuoveReti) }) }} />
              </li>
              <li>
                <p dangerouslySetInnerHTML={{ __html: t('tracciamento_reti.list_item2', { link1: 'mailto:capholding@legalmail.it' }) }} />
              </li>
            </ul>
            <p>
              {t('tracciamento_reti.paragraph2', {})}
            </p>
          </Col>
        </Row>
      </Container>

    </div>
  )
};

TracciamentoNuoveReti.propTypes = {};

export default TracciamentoNuoveReti;
